export class MonthWiseShrimpReq{
    year : number
    month : number
    unitId?:number
    plantId?:number

    constructor(year:number,month:number, unitId?:number,plantId?:number){
        this.year = year
        this.month = month
        this.unitId=unitId
        this.plantId=plantId
    }
}